export type DocumentTemplateId = 'contract' | 'act' | 'order' | 'memo';

export type DocumentTemplate = {
  id: DocumentTemplateId;
  titleKey: string;
  html: string;
};

/**
 * Starter HTML scaffolds wired into the document-editor's template picker.
 * Kept in the renderer's supported tag set (h1-h3, p, ul/ol, strong, em).
 */
export const DOCUMENT_TEMPLATES: DocumentTemplate[] = [
  {
    id: 'contract',
    titleKey: 'document_editor.tpl_contract',
    html: `<h1 style="text-align: center">XİDMƏT MÜQAVİLƏSİ</h1>
<p style="text-align: right"><em>Bakı şəhəri, [tarix]</em></p>
<p>Bir tərəfdən bundan sonra "<strong>Sifarişçi</strong>" adlandırılacaq <strong>[Sifarişçi adı]</strong>, digər tərəfdən isə bundan sonra "<strong>İcraçı</strong>" adlandırılacaq <strong>[İcraçı adı]</strong> aşağıdakı şərtlərlə bu Müqaviləni bağladılar:</p>
<h2>1. MÜQAVİLƏNİN PREDMETİ</h2>
<p>İcraçı Sifarişçinin tapşırığı əsasında aşağıdakı xidmətləri göstərməyi öhdəsinə götürür:</p>
<ul><li>[xidmət 1]</li><li>[xidmət 2]</li></ul>
<h2>2. ÖHDƏLİKLƏR</h2>
<p>2.1. Tərəflər bu Müqavilədə nəzərdə tutulmuş bütün öhdəlikləri lazımi qaydada və müəyyən edilmiş müddətlərdə icra edirlər.</p>
<h2>3. MÜQAVİLƏNİN MÜDDƏTİ</h2>
<p>Müqavilə imzalandığı tarixdən qüvvəyə minir və [tarix]-dək qüvvədədir.</p>
<h2>4. TƏRƏFLƏRİN İMZALARI</h2>
<p><strong>Sifarişçi:</strong> ____________________</p>
<p><strong>İcraçı:</strong> ____________________</p>`,
  },
  {
    id: 'act',
    titleKey: 'document_editor.tpl_act',
    html: `<h1 style="text-align: center">QƏBUL-TƏHVİL AKTI</h1>
<p style="text-align: right"><em>№ [nömrə] · [tarix]</em></p>
<p>Bu Akt aşağıdakı tərəflər arasında bağlanmışdır:</p>
<ul><li><strong>Təhvil verən:</strong> [ad, vəzifə]</li><li><strong>Təhvil alan:</strong> [ad, vəzifə]</li></ul>
<h2>1. AKTIN MƏZMUNU</h2>
<p>Yuxarıda qeyd olunmuş tərəflər aşağıdakıları təsdiq edirlər:</p>
<ol><li>Görülən işlər tam həcmdə icra edilmişdir.</li><li>Keyfiyyət tələblərə cavab verir.</li><li>Tərəflərin bir-birinə qarşı pretenziyası yoxdur.</li></ol>
<h2>2. İMZALAR</h2>
<p><strong>Təhvil verən:</strong> ____________________</p>
<p><strong>Təhvil alan:</strong> ____________________</p>`,
  },
  {
    id: 'order',
    titleKey: 'document_editor.tpl_order',
    html: `<h1 style="text-align: center">Ə M R</h1>
<p style="text-align: center"><strong>№ [nömrə]</strong></p>
<p style="text-align: right"><em>[tarix]</em></p>
<h2>[Əmrin mövzusu]</h2>
<p>[Əmrin əsasını və məqsədini izah edən giriş hissəsi.]</p>
<h2>ƏMR EDİRƏM:</h2>
<ol><li>[Əmrin 1-ci bəndi]</li><li>[Əmrin 2-ci bəndi]</li><li>Əmrin icrasına nəzarət [vəzifə]-ə həvalə edilsin.</li></ol>
<p style="text-align: right"><strong>İmza:</strong> ____________________</p>`,
  },
  {
    id: 'memo',
    titleKey: 'document_editor.tpl_memo',
    html: `<h1>SLUJEBNİ MEMORANDUM</h1>
<p><strong>Kimdən:</strong> [göndərən]</p>
<p><strong>Kimə:</strong> [alan]</p>
<p><strong>Tarix:</strong> [tarix]</p>
<p><strong>Mövzu:</strong> [mövzu]</p>
<hr>
<p>[Memorandumun mətni — qısa, aydın və konkret yazılmalıdır.]</p>
<h3>Tövsiyyələr:</h3>
<ul><li>[tövsiyə 1]</li><li>[tövsiyə 2]</li></ul>
<p>Hörmətlə,<br>[ad, soyad]<br>[vəzifə]</p>`,
  },
];
